//Basics
export const SET_NAME = 'product/SET_NAME'
export const SET_ACTIVE = 'product/SET_ACTIVE'

//Images
export const SET_COVER_IMAGE = 'product/SET_COVER_IMAGE'
export const SET_COVER_IMAGE_NAME = 'product/SET_COVER_IMAGE_NAME'
export const ADD_GALLERY_IMAGE = 'product/ADD_GALLERY_IMAGE'
export const REMOVE_GALLERY_IMAGE = 'product/REMOVE_GALLERY_IMAGE'

//Reset Product
export const RESET_PRODUCT = 'product/RESET_PRODUCT'

//Clone Product
export const CLONE_BEFORE_UPDATE = 'product/CLONE_BEFORE_UPDATE'

const INITIAL_STATE = {
    product: {
        name: '',
        coverImage: null,
        coverImageName: null,
        active: false,
        gallery: {},
    },
    beforeUpdate: null
}

const mutateProductProperty = state => property => value => ({
    ...state,
    product: {
        ...state.product, [property]: value
    }
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_NAME:
            return mutateProductProperty(state)('name')(action.payload)
        case SET_ACTIVE:
            return mutateProductProperty(state)('active')(action.payload)
        case SET_COVER_IMAGE:
            return mutateProductProperty(state)('coverImage')(action.payload)
        case SET_COVER_IMAGE_NAME:
            return mutateProductProperty(state)('coverImageName')(action.payload)
        case ADD_GALLERY_IMAGE:
            return ({
                ...state,
                product: {
                    ...state.product,
                    gallery: { ...state.product.gallery, [action.payload.id]: action.payload }
                }
            })

        case REMOVE_GALLERY_IMAGE:
            let clonedGallery = { ...state.product.gallery }
            delete clonedGallery[action.payload]
            return ({ ...state, product: { ...state.product, gallery: clonedGallery } })
        case RESET_PRODUCT:
            return ({ ...state, ...INITIAL_STATE })
        case CLONE_BEFORE_UPDATE:
            return ({ ...state, beforeUpdate: { ...state.product } })
        default:
            return state
    }
}

export const setName = payload => ({ type: SET_NAME, payload })
export const setActive = payload => ({ type: SET_ACTIVE, payload })
export const setCoverImage = payload => ({ type: SET_COVER_IMAGE, payload })
export const setCoverImageName = payload => ({ type: SET_COVER_IMAGE_NAME, payload })
export const addGalleryImage = payload => ({ type: ADD_GALLERY_IMAGE, payload })
export const removeGalleryImage = payload => ({ type: REMOVE_GALLERY_IMAGE, payload })
export const resetProduct = () => ({ type: RESET_PRODUCT })
export const cloneBeforeUpdate = () => ({ type: CLONE_BEFORE_UPDATE })



// WEBPACK FOOTER //
// ./src/ducks/Corporate.js